import * as go from 'gojs';
import theme from 'theme/theme';
import {
  keepFreePortHoverArrowsAlive,
  showFreePortSmartSelectButton,
} from '../nodeTemplates/utils/freePortHoverArrows';

const $ = go.GraphObject.make;

const PORT_HOVER_BORDER = 'PORT_HOVER_BORDER';

const setPortHoverBorderOpacity = (
  portPanel: go.GraphObject,
  opacity: number,
) => {
  if (!(portPanel instanceof go.Panel)) {
    return;
  }

  const hoverBorder = portPanel.findObject(PORT_HOVER_BORDER);

  if (hoverBorder) {
    hoverBorder.opacity = opacity;
  }
};

const getPortHoverPanel = (obj: go.GraphObject) =>
  obj instanceof go.Panel ? obj : obj.panel;

const handlePortMouseEnter = (_e: go.InputEvent, obj: go.GraphObject) => {
  const portHoverPanel = getPortHoverPanel(obj);

  if (portHoverPanel) {
    setPortHoverBorderOpacity(portHoverPanel, 0.35);
  }

  keepFreePortHoverArrowsAlive(obj);
  showFreePortSmartSelectButton(obj);
};

const handlePortMouseLeave = (_e: go.InputEvent, obj: go.GraphObject) => {
  const portHoverPanel = getPortHoverPanel(obj);

  if (portHoverPanel) {
    setPortHoverBorderOpacity(portHoverPanel, 0);
  }
};

export const makePort = (shape: 'Circle' | 'TriangleDown', options: any) =>
  $(
    go.Panel,
    $(
      go.Panel,
      'Auto',
      {
        width: 32,
        height: 32,
        mouseEnter: handlePortMouseEnter,
        mouseLeave: handlePortMouseLeave,
      },
      $(go.Shape, 'Circle', {
        name: PORT_HOVER_BORDER,
        stroke: null,
        strokeWidth: 0,
        fill: '#C4C4C4',
        pickable: false,
        opacity: 0,
      }),
      $(
        go.Shape,
        shape,
        {
          stroke: null,
          cursor: 'pointer',
          desiredSize: new go.Size(12, 12),
          strokeWidth: 0,
          fill: theme.palette.info.main,
          mouseEnter: handlePortMouseEnter,
          mouseLeave: handlePortMouseLeave,
          ...options,
        },
        new go.Binding('portId', 'key'),
        new go.Binding(
          'fill',
          'color',
          (color) => color ?? theme.palette.info.main,
        ),
      ),
    ),
  );
